import React, { useEffect, useState } from "react";
import { apiClient } from "../../../apiclient/apiclient";
import OrderCard from "./OrderCard";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom"; 
import PageHeader from "../../../components/PageHeader";
import Loader from "../../../components/Loader";
const DeliveredOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 const loadOrders = async () => {
  try {
    setLoading(true);

    const res = await apiClient.get("/all-order?status=delivered");

    console.log("Delivered API response:", res.data); // 🔎 debug

    setOrders(res.data.data || []);
  } catch (error) {
    console.error("Error loading delivered orders", error);
    setOrders([]);
  } finally {
    setLoading(false); // ✅ VERY IMPORTANT
  }
};


  useEffect(() => { loadOrders(); }, []);

  return (
    <div className="">
      <PageHeader
  title="Delivered Orders"
  subtitle="Orders that have been delivered"
  role="agent"
  variant="orange"   // same gradient you liked
  leftContent={
    <button onClick={() => navigate(-1)}>
      <ArrowLeft size={22} />
    </button>
  }
/>
{loading ? (
  <Loader text="Loading delivered orders..." />
) : orders.length === 0 ? (
  <p className="text-gray-500 text-center py-6">
    No delivered orders
  </p>
) : (
  <div className="space-y-4 p-3">
    {orders.map((order) => (
      <OrderCard
        key={order._id}
        order={order}
        reload={loadOrders}
      />
    ))}
  </div>
)}



     {/* {orders.length === 0 && (
        <p className="text-gray-500">No delivered orders</p>
      )}

      <div className="space-y-4 p-3 ">
        {orders.map((order) => (
          <OrderCard
            key={order._id}
            order={order}
            reload={loadOrders}
          />
        ))}
      </div> */}
    </div>
  );
};

export default DeliveredOrders;
